import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Container from '../common/Container';
import AssessmentResults from './AssessmentResults';
import { AssessmentResponse } from '../../api/services/assessment';
import { assessmentService } from '../../api/services/assessment';
import Card from '../common/Card';
import Button from '../common/Button';
import Text from '../common/Text';

const AssessmentSummary: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [assessment, setAssessment] = useState<AssessmentResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAssessment = async () => {
      try {
        const assessment = await assessmentService.getLatestAssessment();
        if (assessment) {
          console.log('Fetched assessment:', assessment);
          setAssessment(assessment);
        } else {
          setError('No assessment data found');
        }
      } catch (err) {
        console.error('Error fetching assessment:', err);
        setError('Failed to load assessment data');
      } finally {
        setLoading(false);
      }
    };

    fetchAssessment();
  }, []);

  if (loading) {
    return (
      <Container>
        <div className="flex items-center justify-center min-h-screen">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        </div>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Card className="max-w-2xl mx-auto">
          <div className="p-6 text-center">
            <Text variant="h2" className="text-red-600 mb-4">Error</Text>
            <Text variant="p" className="mb-6">{error}</Text>
            <Button
              onClick={() => navigate('/skill-diagnostic')}
              variant="secondary"
              size="md"
            >
              Back to Assessments
            </Button>
          </div>
        </Card>
      </Container>
    );
  }

  if (!assessment?.results) {
    return (
      <Container>
        <Card className="max-w-2xl mx-auto">
          <div className="p-6 text-center">
            <Text variant="h2" className="mb-4">No Results Found</Text>
            <Text variant="p" className="mb-6">No assessment results were found. Please complete an assessment first.</Text>
            <Button
              onClick={() => navigate('/skill-diagnostic')}
              variant="primary"
              size="md"
            >
              Take Assessment
            </Button>
          </div>
        </Card>
      </Container>
    );
  }

  return (
    <Container>
      <AssessmentResults
        score={assessment.results.score}
        correctAnswers={assessment.results.correct_answers}
        totalQuestions={assessment.results.total_questions}
        timePerQuestion={assessment.results.time_per_question}
        recommendations={assessment.results.recommendations}
        questions={assessment.questions}
        answers={assessment.answers?.reduce((acc: Record<string, string>, answer: any) => ({
          ...acc,
          [answer.content_id.toString()]: answer.user_answer
        }), {}) || {}}
      />
    </Container>
  );
};

export default AssessmentSummary;